export type RenderedTemplate = {
  url: string;
  pdfUrl: string;
};
